import { render, staticRenderFns } from "./cabinet-ktru-request-create.vue?vue&type=template&id=45d8aa27&scoped=true&"
import script from "./cabinet-ktru-request-create.vue?vue&type=script&lang=js&"
export * from "./cabinet-ktru-request-create.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-ktru-request-create.vue?vue&type=style&index=0&id=45d8aa27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8aa27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d8aa27')) {
      api.createRecord('45d8aa27', component.options)
    } else {
      api.reload('45d8aa27', component.options)
    }
    module.hot.accept("./cabinet-ktru-request-create.vue?vue&type=template&id=45d8aa27&scoped=true&", function () {
      api.rerender('45d8aa27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/ktru/requests/cabinet-ktru-request-create.vue"
export default component.exports